import React from "react";
import ButtonClose from "../button/button-close";

const ModalHeader = (props) => {
    const {onClose, title, className} = props;

    return (
        <header className={className ?? "border-tm-gray-200 border-b text-tm-gray-900"}>
            <div className="p-4 flex justify-between items-center">
                <h2 className="text-lg text-current text-nowrap font-semibold">{title}</h2>

                <div className="grow hidden md:flex">
                    {props.children}
                </div>

                {!props.hideXbtn && (
                    <ButtonClose onClose={onClose}/>
                )}
            </div>

            <div className="flex grow md:hidden pb-4">
                {props.children}
            </div>
        </header>
    )
}

export default ModalHeader;